import PropTypes from 'prop-types'
import React from 'react'

import App from 'components/App'
import Footer from 'components/Footer'
import Nav from 'components/Nav'
import Link from 'components/Link'
import 'base.scss'

const TemplateWrapper = ({ children, location }) => {
  console.log(children);
  return (
    <App location={location}>
      <header className="header">
                <div className="header__bar" style={{ display:'flex', justifyContent:'space-between'  }}>
                  <Link  to='/' className="logo">
                      <img src="https://studiogritt.files.wordpress.com/2018/04/logod12x-1.png" style={{ width:'140px' }} />
                  </Link>
                 

                  <ul className="menu-list">
                    <li><Link className="menu-link" to='/about'><span className="underLine-container"></span>About</Link></li>
                    <li><Link className="menu-link" to='/architecture'><span className="underLine-container"></span>Architecture</Link></li>
                    <li><Link className="menu-link" to='/interiors'><span className="underLine-container"></span>Interiors</Link></li>
                    <li><Link className="menu-link" to='/products'><span className="underLine-container"></span>Products</Link></li>
                    <li><Link className="menu-link" to='/blogs'><span className="underLine-container"></span>Blogs</Link></li>
                    {/* <li><Link className="menu-link" to='/about'><span className="underLine-container"></span>Contact</Link></li> */}

                    
                  </ul>

                  <Nav location={location} />
                </div>

                  
              </header>

      
        {children()} 
      <Footer />
    </App>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js